import React from "react";
import { CaseInfoHeader, CaseInfoHeaderFields } from "../../../../../shared/case-info-header/case-info-header";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useQuery } from "@apollo/client";
import { CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Document } from "../../../../../../generated";

interface CaseInfoHeaderContainerProps {
  caseId: string;
}

export const CaseInfoHeaderContainer: React.FC<CaseInfoHeaderContainerProps> = (
  props
) => {
  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Document, {
    variables: {
      identityVerificationCaseV1Id: props?.caseId,
    },
  });

  const caseInfoData: CaseInfoHeaderFields = {
    applicant: {
      displayName: applicantDetailData?.identityVerificationCaseV1?.applicant?.displayName ?? "",
      id: applicantDetailData?.identityVerificationCaseV1?.applicant?.id ?? "",
    },
    submittedAt: applicantDetailData?.identityVerificationCaseV1?.submittedAt ?? "",
    lastActivityAt: applicantDetailData?.identityVerificationCaseV1?.lastActivityAt ?? "",
    expirationEligibleAt: applicantDetailData?.identityVerificationCaseV1?.expirationEligibleAt ?? "",
    id: applicantDetailData?.identityVerificationCaseV1?.id
  }

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading}
      hasData={applicantDetailData}
      error={applicantDetailError}
      hasDataComponent={
        <CaseInfoHeader
          data={caseInfoData} caseType="identityVerification"
        />
      }
    />
  );
};
